import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import { getAllModules, getPedagogy, deletePedagogy, deleteMultiplePedagogy , getPedagogyFeedback} from '../../services/CourseService';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { pageSizes } from '../../utility/constants';
import { formatSixDigitNumber, capitalizeFirstLetter } from '../../services/CommonService';
import Loader from '../../utility/Loader';

export default function ManagePedagogies() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [userDetails, setUserDetails] = useState({user: {first_name: ""}});
    const [ modules, setModules ] = useState([]);

    const [courseModules, setCourseModules] = useState([]);
    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(0);
    const [selectedModule, setSelectedModule] = useState({});
    const [pedagogy, setPedagogy] = useState([]);
    const [selectedPedagogies, setSelectedPedagogies] = useState({});
    const gridApi = useRef(null);
    const [pedagogyFeedback, setPedagogyFeedback] = useState([]);
    const [colDefs, setColDefs] = useState([
        {
            headerCheckboxSelection: true,
            checkboxSelection: true,
            headerName: 'Select'
            
        },
        {headerName: "Seq No", field: "pedagogy_seq_no", resizable: true },
        {headerName: "Type", field: "pedagogy_type", resizable: true },
        {headerName: 'Status',
            valueGetter: (params) => {
                return params.data.pedagogy_status;
            },
            cellRenderer: params => {
                const onClick = () => {
                    sessionStorage.setItem("pedagogyEdit", JSON.stringify(params.data));
                    routeAddNewPedagogy();                
                };
                return (
                    <>
                        <div onClick={onClick} className='cursor-pointer flex items-center h-full'>
                            {params.data.pedagogy_status === 'PUBLISHED' ? (
                                <div className='active-status text-xs inter-500 leading-none bg-[#EBF9F1] text-[#1F9254] py-2 px-2 rounded-3xl'>Published</div>
                            ) : (
                                null
                            )}
                            {params.data.pedagogy_status === 'DRAFT' ? (
                                <div className='suspend-status text-xs inter-500 leading-none bg-[#FEF2E5] text-[#CD6200] py-2 px-2 rounded-3xl'>Draft</div>
                            ) : (
                                null
                            )}
                            {params.data.pedagogy_status === 'CANCELLED' ? (
                                <div className='cancel-status text-xs inter-500 leading-none bg-[#FBE7E8] text-[#A30D11] py-2 px-2 rounded-3xl'>Cancelled</div>
                            ) : (
                                null
                            )}
                        </div>
                    </>
                );
            },
            sortable: true,
            filter: true
        },
        {headerName: "Title", field: "title", resizable: true, tooltipValueGetter: (p) =>
            p.value
        },
        {headerName: "Text", field: "text", resizable: true,
            cellRenderer: params => {
                return (
                    <>
                        <p className='' dangerouslySetInnerHTML={{ __html: params.data.text.substring(0, 300) }} />
                    </>
                )
            }
        },
        {headerName: "Feedback", 
            resizable: true,
            cellRenderer: params => {
                return (
                    <>
                        <div className='video-action-row flex items-center mt-2 mb-1'>
                            <div className='video-action-sngle mr-3 flex items-center'>
                                <div className='video-action-btn btn-like transition duration-300'>
                                    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M12.444 1.35396C11.6474 0.955692 10.6814 1.33507 10.3687 2.16892L7.807 9.00001L4 9.00001C2.34315 9.00001 1 10.3432 1 12V20C1 21.6569 2.34315 23 4 23H18.3737C19.7948 23 21.0208 22.003 21.3107 20.6119L22.9773 12.6119C23.3654 10.7489 21.9433 9.00001 20.0404 9.00001H14.8874L15.6259 6.7846C16.2554 4.89615 15.4005 2.8322 13.62 1.94198L12.444 1.35396ZM9.67966 9.70225L12.0463 3.39119L12.7256 3.73083C13.6158 4.17595 14.0433 5.20792 13.7285 6.15215L12.9901 8.36755C12.5584 9.66261 13.5223 11 14.8874 11H20.0404C20.6747 11 21.1487 11.583 21.0194 12.204L20.8535 13H17C16.4477 13 16 13.4477 16 14C16 14.5523 16.4477 15 17 15H20.4369L20.0202 17H17C16.4477 17 16 17.4477 16 18C16 18.5523 16.4477 19 17 19H19.6035L19.3527 20.204C19.2561 20.6677 18.8474 21 18.3737 21H8V10.9907C8.75416 10.9179 9.40973 10.4221 9.67966 9.70225ZM6 11H4C3.44772 11 3 11.4477 3 12V20C3 20.5523 3.44772 21 4 21H6V11Z" fill="var(--secondary-color)"/>
                                    </svg>
                                </div>
                                <span className="text-sm inter-400 text-secondary ml-1">{params.data.likeness_count}</span>
                            </div>
                            <div className='video-action-sngle mr-3 flex items-center'>
                                <div className='video-action-btn btn-dislike transition duration-300'>
                                    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M11.556 22.646C12.3525 23.0443 13.3186 22.6649 13.6313 21.8311L16.193 15L20 15C21.6568 15 23 13.6569 23 12L23 4C23 2.34315 21.6568 1 20 1L5.62625 1C4.20523 1 2.97914 1.99698 2.68931 3.38814L1.02265 11.3881C0.634535 13.2511 2.05665 15 3.95959 15H9.11255L8.37409 17.2154C7.7446 19.1039 8.59952 21.1678 10.38 22.058L11.556 22.646ZM14.3203 14.2978L11.9537 20.6088L11.2744 20.2692C10.3842 19.8241 9.95671 18.7921 10.2715 17.8479L11.0099 15.6325C11.4416 14.3374 10.4777 13 9.11256 13H3.95959C3.32527 13 2.85124 12.417 2.98061 11.7961L3.14645 11L6.99998 11C7.55226 11 7.99998 10.5523 7.99998 10C7.99998 9.44772 7.55226 9.00001 6.99998 9.00001L3.56312 9.00001L3.97978 7.00001L6.99998 7.00001C7.55226 7.00001 7.99998 6.55229 7.99998 6.00001C7.99998 5.44772 7.55226 5.00001 6.99998 5.00001L4.39645 5.00001L4.64727 3.79605C4.74388 3.33233 5.15258 3 5.62625 3L16 3L16 13.0093C15.2458 13.0821 14.5903 13.5779 14.3203 14.2978ZM18 13H20C20.5523 13 21 12.5523 21 12L21 4C21 3.44772 20.5523 3 20 3L18 3L18 13Z" fill="var(--secondary-color)"/>
                                    </svg>
                                </div>
                                <span className="text-sm inter-400 text-secondary ml-1">{params.data.dislikeness_count}</span>
                            </div>
                            <div className='video-action-sngle flex items-center'>
                                <button onClick={() => openFeedback(params.data)} className='video-action-btn btn-feedback hover:-translate-y-1.5 transition duration-300'>
                                    <svg width="24px" height="24px" viewBox="2.5 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.0001 8.517C8.58589 8.517 8.2501 8.85279 8.2501 9.267C8.2501 9.68121 8.58589 10.017 9.0001 10.017V8.517ZM16.0001 10.017C16.4143 10.017 16.7501 9.68121 16.7501 9.267C16.7501 8.85279 16.4143 8.517 16.0001 8.517V10.017ZM9.8751 11.076C9.46089 11.076 9.1251 11.4118 9.1251 11.826C9.1251 12.2402 9.46089 12.576 9.8751 12.576V11.076ZM15.1251 12.576C15.5393 12.576 15.8751 12.2402 15.8751 11.826C15.8751 11.4118 15.5393 11.076 15.1251 11.076V12.576ZM9.1631 5V4.24998L9.15763 4.25002L9.1631 5ZM15.8381 5L15.8438 4.25H15.8381V5ZM19.5001 8.717L18.7501 8.71149V8.717H19.5001ZM19.5001 13.23H18.7501L18.7501 13.2355L19.5001 13.23ZM18.4384 15.8472L17.9042 15.3207L17.9042 15.3207L18.4384 15.8472ZM15.8371 16.947V17.697L15.8426 17.697L15.8371 16.947ZM9.1631 16.947V16.197C9.03469 16.197 8.90843 16.23 8.79641 16.2928L9.1631 16.947ZM5.5001 19H4.7501C4.7501 19.2662 4.89125 19.5125 5.12097 19.6471C5.35068 19.7817 5.63454 19.7844 5.86679 19.6542L5.5001 19ZM5.5001 8.717H6.25012L6.25008 8.71149L5.5001 8.717ZM6.56175 6.09984L6.02756 5.5734H6.02756L6.56175 6.09984ZM9.0001 10.017H16.0001V8.517H9.0001V10.017ZM9.8751 12.576H15.1251V11.076H9.8751V12.576ZM9.1631 5.75H15.8381V4.25H9.1631V5.75ZM15.8324 5.74998C17.4559 5.76225 18.762 7.08806 18.7501 8.71149L20.2501 8.72251C20.2681 6.2708 18.2955 4.26856 15.8438 4.25002L15.8324 5.74998ZM18.7501 8.717V13.23H20.2501V8.717H18.7501ZM18.7501 13.2355C18.7558 14.0153 18.4516 14.7653 17.9042 15.3207L18.9726 16.3736C19.7992 15.5348 20.2587 14.4021 20.2501 13.2245L18.7501 13.2355ZM17.9042 15.3207C17.3569 15.8761 16.6114 16.1913 15.8316 16.197L15.8426 17.697C17.0201 17.6884 18.1461 17.2124 18.9726 16.3736L17.9042 15.3207ZM15.8371 16.197H9.1631V17.697H15.8371V16.197ZM8.79641 16.2928L5.13341 18.3458L5.86679 19.6542L9.52979 17.6012L8.79641 16.2928ZM6.2501 19V8.717H4.7501V19H6.2501ZM6.25008 8.71149C6.24435 7.93175 6.54862 7.18167 7.09595 6.62627L6.02756 5.5734C5.20098 6.41216 4.74147 7.54494 4.75012 8.72251L6.25008 8.71149ZM7.09595 6.62627C7.64328 6.07088 8.38882 5.75566 9.16857 5.74998L9.15763 4.25002C7.98006 4.2586 6.85413 4.73464 6.02756 5.5734L7.09595 6.62627Z" fill="var(--secondary-color)"/>
                                    </svg>

                                </button>
                            </div>
                        </div>
                    </>
                );
            },
        },
        {headerName: 'Actions',
            resizable: true,
            cellRenderer: params => {
                const onClickEdit = () => {
                    sessionStorage.setItem("pedagogyEdit", JSON.stringify(params.data));
                    routeAddNewPedagogy();
                };
                const onClickDelete = async () => {
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to revert this!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, delete it!',
                        cancelButtonText: 'No, cancel!',
                        reverseButtons: true
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            const userDetails = getUserDetails();
                            setLoading(true);
                            let resp = await deletePedagogy(userDetails.token, params.data.id);
                            if(resp.error){
                                toast.error(resp.data);
                            }else{
                                getPedagogyData(params.data.module_id);
                                toast.success(resp.data);
                            }
                            setLoading(false);
                            
                        } 
                    });

                };

                return (
                    <>
                        <div className='relative course-navigate-btns flex items-center justify-between h-full'>
                            <a onClick={onClickEdit} className='cursor-pointer flex items-center justify-center transition duration-300'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                    <path d="M11.083 4H4.08301C3.55257 4 3.04387 4.21071 2.66879 4.58579C2.29372 4.96086 2.08301 5.46957 2.08301 6V20C2.08301 20.5304 2.29372 21.0391 2.66879 21.4142C3.04387 21.7893 3.55257 22 4.08301 22H18.083C18.6134 22 19.1221 21.7893 19.4972 21.4142C19.8723 21.0391 20.083 20.5304 20.083 20V13" stroke="#624DE3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M18.583 2.49998C18.9808 2.10216 19.5204 1.87866 20.083 1.87866C20.6456 1.87866 21.1852 2.10216 21.583 2.49998C21.9808 2.89781 22.2043 3.43737 22.2043 3.99998C22.2043 4.56259 21.9808 5.10216 21.583 5.49998L12.083 15L8.08301 16L9.08301 12L18.583 2.49998Z" stroke="#624DE3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </a>
                            <a onClick={onClickDelete} className='cursor-pointer flex items-center justify-center transition duration-300'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                    <path d="M3.08301 6H5.08301H21.083" stroke="#A30D11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M8.08301 6V4C8.08301 3.46957 8.29372 2.96086 8.66879 2.58579C9.04387 2.21071 9.55257 2 10.083 2H14.083C14.6134 2 15.1221 2.21071 15.4972 2.58579C15.8723 2.96086 16.083 3.46957 16.083 4V6M19.083 6V20C19.083 20.5304 18.8723 21.0391 18.4972 21.4142C18.1221 21.7893 17.6134 22 17.083 22H7.08301C6.55257 22 6.04387 21.7893 5.66879 21.4142C5.29372 21.0391 5.08301 20.5304 5.08301 20V6H19.083Z" stroke="#A30D11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M10.083 11V17" stroke="#A30D11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M14.083 11V17" stroke="#A30D11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </a>
                        </div>
                    </>
                );
            },
            
        }
    ]);
    const defaultColDef = useMemo(() => {
        return {
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            flex: 1,
            minWidth: 150,
        };
    }, []);
    useEffect(() => {
        const userDetails = getUserDetails();
        if(userDetails.token === undefined){
            navigate('/login');
        }else{
            setUserDetails(userDetails);
            getAllModulesData(userDetails.token);
        }
    },[]);

    const openFeedback = async (pd) => {
        setLoading(true);
        const usrDtl = getUserDetails();
        let allFeedbacks = [];
        let feedbacks = await getPedagogyFeedback(usrDtl.token, pd.id);
        if(feedbacks.error === false){
            let data = feedbacks.data;
            if(data !== null && data !== undefined){
                setPedagogyFeedback(data);
                allFeedbacks = data;
            }else{
                setPedagogyFeedback([]);
                allFeedbacks = [];
            }
        }else{
            setPedagogyFeedback([]);
            toast.error("Some error occurred while getting pedagogies!")
        }
        setLoading(false);
        Swal.fire({
            title: "Feedback List",
            html: `
                <table style="width:100%; border-collapse: collapse;">
                    <thead>
                        <tr>
                            <th style="border: 1px solid #ccc; padding: 8px;">#</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Feedback</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${allFeedbacks.map((item, index) => `
                            <tr>
                                <td style="border: 1px solid #ccc; padding: 8px; text-align:center;">${index + 1}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">${item.feedback}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
            `,
            width: 600,
            showConfirmButton: true,
            confirmButtonText: "OK",
        });
        
    };

    const getAllModulesData = async (token) => {
        setLoading(true);
        const modulesData = await getAllModules(token);
        if(modulesData.error === false){
            let allModules = modulesData.data;
            let courseObj = {};
            for(let i=0;i<allModules.length; i++){
                allModules[i]["module_id"] = allModules[i]["id"];
                if(courseObj[allModules[i].course_id] === undefined){
                    courseObj[allModules[i].course_id] = {label: allModules[i].course_name, value: allModules[i].course_id};

                }
            }
            setCourses(Object.values(courseObj));
            setModules(allModules);
            let moduleValue = sessionStorage.getItem('moduleValue') === null ? null : JSON.parse(sessionStorage.getItem('moduleValue'));
            if(moduleValue !== null){
                await handleCourseValueChange(moduleValue.course_id, allModules);
            }else{
                await handleCourseValueChange(allModules[0].course_id, allModules);
            }
            
        }
        if (gridApi.current) {
            gridApi.current.refreshCells();
        }
        setLoading(false);
    };

    const handleCourseValueChange = async (value, modules) => {
        setLoading(true);
        setSelectedCourse(value);
        let allModules = [];
        for(let i=0; i<modules.length; i++){
            if(parseInt(modules[i].course_id) === parseInt(value) && modules[i].module_type !== 'ASSESSMENT'){
                allModules.push({...modules[i], label: modules[i].module_seq_no + " - " + modules[i].module_name, value: modules[i].id})
            }
        }
        setCourseModules(allModules);
        let moduleValue = sessionStorage.getItem('moduleValue') === null ? null : JSON.parse(sessionStorage.getItem('moduleValue'));
        if(moduleValue !== null && moduleValue.module_type === 'THEORY'){
            await handleModuleValueChange(moduleValue);
        }else{
            if(allModules.length > 0){
                await handleModuleValueChange(allModules[0]);
            }else{
                setSelectedModule({});
                setPedagogy([]);
            }

        }
        
        setLoading(false);
    };

    const onCellClicked = (event) => {
        if (event.column.colId === 'text') {
            Swal.fire({
                title: "Text",
                html: 
                `                        
                <p className=''>
                ${event.value}
                </p>
                ` ,
                showConfirmButton: true,
                confirmButtonText: "OK",
            });
        }
        if (event.column.colId === 'pedagogy_type' && event.data.pedagogy_type === "VIDEO") {
            Swal.fire({
                title: "Video",
                html: 
                `                        
                <video controls>
                    <source src=${event.data.url} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                ` ,
                showConfirmButton: true,
                confirmButtonText: "OK",
            });
        }

    };

    const handleModuleValueChange = async (moduleValue) => {
        setLoading(true);
        setSelectedModule(moduleValue);
        sessionStorage.setItem('selectedModule', JSON.stringify(moduleValue));
        const usrDtl = getUserDetails();
        let pedagogyData = await getPedagogy(usrDtl.token, moduleValue.value);
        if(pedagogyData.error === false){
            let data = pedagogyData.data;
            for(let i=0;i<data.length; i++){
                data[i]["selected"] = false;
                if(data[i]["title"] === null || data[i]["title"] === undefined){
                    data[i]["title"] = "";
                }
                if(data[i]["text"] === null || data[i]["text"] === undefined){
                    data[i]["text"] = "";
                }
            }
            setPedagogy(data);
        }else{
            setPedagogy([]);
            toast.error("Some error occurred while getting pedagogies!")
        }
        setLoading(false); 
    };

    const getPedagogyData = async (value) => {
        setLoading(true);
        const usrDtl = getUserDetails();
        let pedagogyData = await getPedagogy(usrDtl.token, value);
        if(pedagogyData.error === false){
            let data = pedagogyData.data;
            for(let i=0;i<data.length; i++){
                data[i]["selected"] = false;
                if(data[i]["title"] === null || data[i]["title"] === undefined){
                    data[i]["title"] = "";
                }
                if(data[i]["text"] === null || data[i]["text"] === undefined){
                    data[i]["text"] = "";
                }
            }
            setPedagogy(data);
        }else{
            setPedagogy([]);
            toast.error("Some error occurred while getting pedagogies!")
        }
        setLoading(false); 
    };

    const routeAddNewPedagogy = async () => {
        let moduleSelected = sessionStorage.getItem('selectedModule') === null ? {} : JSON.parse(sessionStorage.getItem('selectedModule'));
        if(moduleSelected.module_id !== undefined){
            sessionStorage.setItem('moduleValue', JSON.stringify(moduleSelected));
            navigate('/superadmin/addpedagogy');
        }else {
            toast.error("No Module is selected!");
        }

    };

    const previewPedagogy = async () => {
        if(pedagogy.length > 0){
            sessionStorage.setItem('pedagogyPreview', JSON.stringify(pedagogy));
            navigate('/superadmin/previewpedagogy');
        }else{
            toast.error("No Pedagogy Found for Preview");
        }
    };

    const editSequence = async () => {
        if(pedagogy.length > 0){
            sessionStorage.setItem('pedagogies', JSON.stringify(pedagogy));
            navigate('/superadmin/editpedagogysequence');
        }else{
            toast.error("No Pedagogy Found for Edit");
        }
    };

    const deleteAll = async () => {
        if (gridApi.current && gridApi.current.api) {
            const selectedNodes = gridApi.current.api.getSelectedNodes();
            const selectedIds = selectedNodes.map(node => node.data.id);            
            if(selectedIds.length > 0){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        const userDetails = getUserDetails();
                        setLoading(true);
                        let resp = await deleteMultiplePedagogy(userDetails.token, {ids: selectedIds});
                        if(resp.error === false){
                            toast.success("Pedagogies Deleted!");
                            if(pedagogy.length > 0){
                                await getPedagogyData(pedagogy[0].module_id);
                            }
                        }else{
                            toast.error("Some Error occurred!");
                        }
                        setLoading(false);
                        
                    } 
                });
            }else{
                toast.warn("Nothing to delete!");
            }
        }
        
    };

    return (
        <div>
            {loading ? (
                <Loader />
            ) : (
                <div className='py-10'>
                    <h3 className='text-2xl text-secondary inter-700 lg:hidden mb-6 px-6'>Manage Pedagogy</h3>
                    <div className='flex justify-between flex-wrap lg:mx-12 lg:px-0 px-6 pb-5 mb-6 border-b-2 border-[#D0D0D0]'>
                        <button onClick={() => previewPedagogy()} type="button" className='bg-tertiary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow w-full md:w-auto mb-5 md:mb-0'>Preview Pedagogy</button>
                        <button onClick={() => routeAddNewPedagogy()} type="button" className='bg-secondary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow w-full md:w-auto'>+ Add New Pedagogy</button>
                    </div>
                    <div className='flex justify-between flex-wrap mb-4 md:mb-6 lg:px-20 px-6'>
                        <div className='order-2 lg:order-1 lg:w-[12.5%]'>
                            <button type="button" onClick={() => deleteAll()} className='bg-[#E76457] hover:bg-black flex items-center justify-center px-5 h-8 2xl:h-12 text-white inter-600 text-sm 2xl:text-base rounded-3xl lg:rounded-full transition duration-300 button-shadow w-full md:w-auto'>Delete</button>
                        </div>
                        <div className='order-1 lg:order-2 flex flex-wrap justify-center items-center w-full lg:w-3/4 md:mb-8 lg:mb-0'>
                            <div className='w-full md:w-2/5 md:mr-6 mb-4 md:mb-0'>
                                <Select placeholder="Select Course Name" className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md relative z-10'
                                    options={courses}
                                    value={courses.find(option => option.value === selectedCourse)}
                                    onChange={(values) => handleCourseValueChange(values.value, modules)}
                                />
                            </div>
                            <div className='w-full md:w-2/5  md:mr-6 mb-4 md:mb-0'>
                                <Select placeholder="Select Module Name" className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md relative z-10'
                                    options={courseModules}
                                    value={courseModules.find(option => option.value === selectedModule.value)}
                                    onChange={(values) => handleModuleValueChange(values)}
                                />
                            </div>
                        </div>
                        <div className='order-3 lg:order-3 lg:w-[12.5%] flex justify-end'>
                            <button onClick={() => editSequence()} type="button" className='bg-[#C13F63] hover:bg-black flex items-center justify-center px-5 h-8 2xl:h-12 text-white inter-600 text-sm 2xl:text-base rounded-3xl lg:rounded-full transition duration-300 button-shadow w-full md:w-auto'>Edit</button>
                        </div>
                    </div>
                    <div className='lg:px-20 px-6'>
                        {modules.length > 0 ? (
                            <div
                            className="ag-theme-quartz"  
                            style={{ width: '100%', height: 500 }} // the Data Grid will fill the size of the parent container
                            >
                                <AgGridReact
                                    ref={gridApi}
                                    rowData={pedagogy}
                                    columnDefs={colDefs}
                                    rowSelection="multiple"
                                    defaultColDef={defaultColDef}
                                    suppressRowClickSelection={true}
                                    pagination={true}
                                    paginationPageSize={20}
                                    paginationPageSizeSelector={pageSizes}
                                    // onGridReady={onGridReady}
                                    tooltipShowDelay={500}
                                    rowClass='rowClass'
                                    onCellClicked={onCellClicked}
                                />
                            </div>
                        ) : (
                            null
                        )}

                    </div>
                </div>
            )}
        </div>
    );
}